export default [
  {
    path: '/stations',
    name: 'stations',
    component: () => import('../../views/stations/stations.vue'),
    meta: {
      pageTitle: 'Stations',
      breadcrumbs: ['Stations'],
    },
    children: [
      {
        path: '',
        name: 'stations-list',
        component: () => import('../../views/stations/list.vue'),
        meta: {
          permissions: ['stations.read']
        }
      },
      {
        path: 'create',
        name: 'stations-create',
        component: () => import('../../views/stations/create.vue'),
        meta: {
          pageTitle: 'Create Stations',
          breadcrumbs: ['Stations', 'Create'],
          permissions: ['stations.create']
        }
      },
      {
        path: ':id/edit',
        name: 'stations-edit',
        component: () => import('../../views/stations/edit.vue'),
        meta: {
          pageTitle: 'Edit Station',
          breadcrumbs: ['Stations', 'Edit'],
        }
      },
    ]
  }
]
